/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerCancelMutationRequest, JobsControllerCancelMutationResponse, JobsControllerCancelPathParams, JobsControllerCancel400, JobsControllerCancel404 } from "../../models/jobsController/JobsControllerCancel";

function getJobsControllerCancelUrl(id: JobsControllerCancelPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/jobs/${id}/cancel` as const }  
  return res
}

/**
 * @description Cancel a job that is in a cancellable state (PENDING, QUEUED, START, PROCESSING). Dependent jobs will be marked as OMITTED.
 * @summary Cancel a job
 * {@link /api/v1/jobs/:id/cancel}
 */
export async function jobsControllerCancel(id: JobsControllerCancelPathParams["id"], data?: JobsControllerCancelMutationRequest, config: Partial<RequestConfig<JobsControllerCancelMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<JobsControllerCancelMutationResponse, ResponseErrorConfig<JobsControllerCancel400 | JobsControllerCancel404>, JobsControllerCancelMutationRequest>({ method : "POST", url : getJobsControllerCancelUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}